import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import type { GetServerSideProps, NextPage } from 'next';
import Head from 'next/head';
import Link from 'next/link'

import cName from 'classnames';
import styles from './styles.module.scss';

import Wrapper from '@/components/wrapper';
import { Notification } from '@douyinfe/semi-ui';

import request from '@/utils/request';
import { getServerSideProps as _getServerSideProps } from '@/utils/useHead';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { useTranslations } from "next-intl";
import { useRouter } from "next/router";

interface IProps {

}
export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context);
  const { newsId } = context.query;
  const { data } = await request.get(`/api/news/${newsId}?lang=${context.locale || context.defaultLocale || 'cn'}`)
  return {
    props: {
      ...res.props,
      data: data?.data || null,
    }
  }
}

const Detail: NextPage<IProps> = ({ menuDetail, data }: any) => {
  const router = useRouter();
  const t = useTranslations("media.detail");

  return (
    <div>
      <Wrapper
        crumb={[
          { name: data?.info?.title || '', path: `/media/news/news_detail/${data?.id}`, isActive: true },
        ]}
      >
        <div className={cName(styles.container, 'm-1600')}>
          <Head>
            <title>{data?.info?.meta_title || data?.info?.title}</title>
            {data?.info?.meta_kws && <meta name="keywords" content={data?.info?.meta_kws} />}
            {data?.info?.desc && <meta name="description" content={data?.info?.desc} />}
          </Head>
          <div className={styles.left}>
            <h1>{data?.info?.title}</h1>
            <div className={styles.header}>
              <span className={styles.date}>{new Date(data?.publish_time * 1000).toLocaleString().replace(/\//g, '-').split(' ')[0]}</span>
              <div className={styles.btns}>
                <CopyToClipboard text={`${process.env.NEXT_PUBLIC_FRONT_URL}/media/news/news_detail/${data?.id}`}
                  onCopy={() => {
                    Notification.success({
                      content: t('share'),
                      duration: 3,
                    })
                  }}
                >
                  <div className={cName(styles.icon, styles.wx)}></div>
                </CopyToClipboard>
                <div className={cName(styles.icon, styles.xinlang)}
                  onClick={() => {
                    window.open(
                      "https://service.weibo.com/share/share.php?url=" +
                      encodeURIComponent(`${process.env.NEXT_PUBLIC_FRONT_URL}/media/news/news_detail/${data?.id}`) +
                      "?sharesource=weibo&title=" +
                      data?.info?.title
                    )
                  }}></div>
              </div>
            </div>
            <div className={styles.content} dangerouslySetInnerHTML={{ __html: data?.info?.content }} />
            <div className={styles.footer}>
              {
                data?.prev_article ? (
                  <Link href={data?.prev_article?.info?.outlink
                    ? data?.prev_article?.info?.outlink
                    : `/media/news/news_detail/${data?.prev_article?.id}`}>
                    <a target={data?.prev_article?.info?.outlink ? "_blank" : ''}>
                      {t('prev')}{data?.prev_article?.info?.title}
                    </a>
                  </Link>
                ) : <div></div>
              }
              {
                data?.next_article ? (
                  <Link href={data?.next_article?.info?.outlink
                    ? data?.next_article?.info?.outlink
                    : `/media/news/news_detail/${data?.next_article?.id}`}>
                    <a target={data?.next_article?.info?.outlink ? "_blank" : ''}>
                      {t('next')}{data?.next_article?.info?.title}
                    </a>
                  </Link>
                ) : <div></div>
              }
            </div>
          </div>
          <div className={styles.right}>
            <h2>{t('more')}</h2>
            {
              data?.related_articles?.map((item: any) => (
                <Link key={item.id} href={item.info.outlink
                  ? `${item.info.outlink}` :
                  `/media/news/news_detail/${item.id}`}>
                  <a target={item.info.outlink ? "_blank" : ''}>
                    <div className={styles.item}>
                      <img className={styles.cover} src={item.info.image} alt={item.info.title} />
                      <div className={styles.info}>
                        <h3>{item.info.title}</h3>
                        <p>{item.info.brief}</p>
                        <span>{new Date(item.publish_time * 1000).toLocaleString().replace(/\//g, '-').split(' ')[0]}</span>
                        <img src="/image/news-bg-btn.png" alt="" />
                      </div>
                    </div>
                  </a>
                </Link>
              ))
            }
          </div>
        </div>
      </Wrapper >
    </div >
  );
};

export default Detail;